// Kept apart from data.ts so the nav and footer can read it without pulling the
// post bodies into the main bundle. tests/unit/blogEnabled.test.ts fails if it
// disagrees with blogPosts, so publishing a post forces this back on.
export const BLOG_ENABLED = false;
